import { NOTICES } from '@df/ui/api/notice/notice.const';

export const VALIDATE_PATTERN_ERROR_PREFIX = 'validatePattern';

export interface IValidatePatternConfig {
    pattern: RegExp | string;
    errorMessage?: string;
}

export function getValidatePatternErrorMessage(errorName: string): string | undefined {
    const isValidatePatternErrorName = errorName.indexOf(VALIDATE_PATTERN_ERROR_PREFIX) === 0;
    
    if (isValidatePatternErrorName) {
        const validatePatternError = errorName.slice(VALIDATE_PATTERN_ERROR_PREFIX.length);

        if (validatePatternError) {
            const errorConfiguration = validatePatternConfiguration[validatePatternError];

            if (errorConfiguration) {
                return errorConfiguration.errorMessage;
            }
        }
    }

    return undefined;
}

export const validatePatternConfiguration: { [key: string]: IValidatePatternConfig } = {
    email: {
        pattern: /^[a-zA-Z0-9.!#$%&'*+-\/=?^_`{|}~]+@[a-zA-Z0-9-]+\.[.a-zA-Z0-9]+$/,
        errorMessage: NOTICES['INVLIDEMAILFIELD']
    },
    telephone: {
        pattern: /^(\+)?[0-9()-\s]+$/,
        errorMessage: NOTICES['INVLIDPHONEFIELD']
    }
};
